import React from 'react';
import { useStore } from 'effector-react';
import { Sidebar } from '@modules/sidebar';
import { CategoryBar } from '@modules/category';
import { SceneLayers, ScenePlayer } from '@modules/player';
import { RotateEditor } from '@modules/autoRotate/RotateEditor';
import { $GateRotateEditMode } from '@stores/autoRotateStores';

function PageMain() {
  const isRotateEditMode = useStore($GateRotateEditMode.state);
  return (
    <>
      <div className="mx-10 flex flex-grow flex-col">
        <div className="relative flex flex-grow items-center justify-center overflow-hidden rounded bg-black-#28">
          <ScenePlayer />
          <SceneLayers />
        </div>
        {isRotateEditMode ? <RotateEditor /> : <CategoryBar />}
      </div>
      <Sidebar />
    </>
  );
}

export default PageMain;
